export default __webpack_public_path__ + "static/search-1deb940a99982c08a8aa59e48265a490.mp3";